import { Text } from "react-native-paper";

import Icon from "@react-native-vector-icons/material-design-icons/static";
import type { IconType } from "../../icon";
import { useAppTheme } from "../../useAppTheme";
import Box from "../Box";
import RenderMarkdown from "../MarkdownRenderer";

type FeedbackHeaderProps = {
	subtitle?: string;
	icon?: IconType;
	title?: string;
};

export const FeedbackHeader = ({
	title,
	subtitle,
	icon,
}: FeedbackHeaderProps) => {
	const theme = useAppTheme();

	return (
		<Box padding={24} gap={16} alignItems="center">
			{icon ? (
				<Icon name={icon} size={24} color={theme.colors.secondary} />
			) : null}
			<Text
				variant="headlineSmall"
				style={{ textAlign: "center", color: theme.colors.onSurface }}
			>
				{title}
			</Text>
			<RenderMarkdown
				text={subtitle}
				textAlign="center"
				customStyles={{
					text: {
						color: theme.colors.onSurfaceVariant,
					},
				}}
			/>
		</Box>
	);
};
